<div class="d-inline-block border px-3 rounded fw-normal align-top text-center fs-12"
    [ngClass]="'border-' + color + ' text-' + color + ' bg-' + color + '-light'">
    {{label}}
</div>